angular.module('impactx.company').controller('SupplierCreationCtrl', [
    '$scope',
    'dataGen',
    'TranslationService',
    '$routeParams',
    'BackService',
    'ToastService',
    'ToolbarService',
    SupplierCreationCtrl]);

function SupplierCreationCtrl($scope, dataGen, TranslationService, $routeParams, BackService, ToastService, ToolbarService) {
    var self = this;
    dataGen.getData($scope, {}, "/company/suppliercreation/view").then(function (data) {
        $scope.trns.save = TranslationService.get('save');
        $scope.trns.required = TranslationService.get('required');
        $scope.trns.noSelectedItemMessage = TranslationService.get('noSelectedItemMessage');
        defineButtons();
    });

    this.save = function () {
        return dataGen.postAsForm($scope, {creationData: $scope.data}, "/company/suppliercreation/save").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            BackService.back();
        });
    };

    function defineButtons() {
        var buttonDefinition = [{
            label: $scope.trns.save,
            action: self.save,
            type: 'validation',
            params: {
                form: $scope.dialogData
            }
        }];
        ToolbarService.setButtons(buttonDefinition);
    }
}